import React from 'react';
import moment from 'moment';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { delimitNumber } from '@src/utils/number';

const NextResetCycle = ({ creditsPerCycle, nextResetAt }) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;

  const formattedNextResetAt = moment(nextResetAt)
    .add(1, 'days')
    .format('DD/MM/YYYY');

  return (
    <Typography className="next-reset-cycle">
      {t('nextResetCycle', {
        creditsPerCycle: delimitNumber(creditsPerCycle, language),
        formattedNextResetAt,
      })}
    </Typography>
  );
};

export default NextResetCycle;
